export const airportData = [
    {
      icao: 'efro',
      fmisid: '137190',
      qfesub: 23.2,
      windmeters: [
        { name: "03 TDZ", x: 100, y: 50, x2: 40, y2: 460, type: "end", rwyh: 37.2 },
        { name: "03 MID", x: 440, y: 50, x2: 800, y2: 330, type: "mid", rwyh: 37.2 },
        { name: "21 TDZ", x: 786, y: 50, x2: 266, y2: 40, type: "end", rwyh: 37.2 }
      ],
      ceilometers: [
        { name: "03 EXT", x: 100, y: 600, x2: 560, y2: 630  },
        { name: "21 TDZ", x: 800, y: 600, x2: 850, y2: 100 }
      ],
      rvr: [
        { name: "RVR 03 TDZ" },{ name: "RVR 03 MID" },{ name: "RVR 21 TDZ" }
      ],
      weather: { x: 480, y: 590, x2: 80, y2: 310 },
      twrLocation: {x: 390, y: 290}
    },
    {
      icao: 'efet',
      fmisid: '101976',
      qfesub: 36.6,
      windmeters: [
        { name: "21 MID", x: 440, y: 50, x2: 160, y2: 140, type: "mid", rwyh: 34.7 },
      ],
      ceilometers: [
        { name: "21 TDZ", x: 760, y: 600, x2: 830, y2: 230  },
      ],
      rvr: [
        { name: "RVR 21 TDZ" }
      ],
      weather: { x: 300, y: 610, x2: 700, y2: 540 },
      twrLocation: {x: 300, y: 290}
    },
    {
      icao: 'efha',
      fmisid: '101315',
      qfesub: 17.6,
      windmeters: [
        { name: "08 TDZ", x: 100, y: 50, x2: 100, y2: 50, type: "end", rwyh: 86.1 },
        { name: "26 TDZ", x: 786, y: 50, x2: 786, y2: 50, type: "end", rwyh: 86.1 }
      ],
      ceilometers: [
        { name: "08 THR", x: 100, y: 600, x2: 100, y2: 600  },
        { name: "26 TDZ", x: 800, y: 600, x2: 800, y2: 600 }
      ],
      rvr: [
        { name: "RVR 08 TDZ" },{ name: "RVR 26 TDZ" }
      ],
      weather: { x: 416, y: 590, x2: 416, y2: 590 },
      twrLocation: {x: 380, y: 280}
    },
    {
      icao: 'efiv',
      fmisid: '102033',
      qfesub: 17.7,
      windmeters: [
        { name: "04 TDZ", x: 100, y: 50, x2: 20, y2: 460, type: "end", rwyh: 47.0 },
        { name: "04/22 MID", x: 440, y: 50, x2: 800, y2: 380, type: "mid", rwyh: 47.0 },
        { name: "22 TDZ", x: 786, y: 50, x2: 320, y2: 40, type: "end", rwyh: 47.0 }
      ],
      ceilometers: [
        { name: "04 TDZ", x: 100, y: 600, x2: 540, y2: 620  },
        { name: "22 EXT", x: 800, y: 600, x2: 850, y2: 100 }
      ],
      rvr: [
        { name: "RVR 04 TDZ" },{ name: "RVR 04/22 MID" },{ name: "RVR 22 TDZ" }
      ],
      weather: { x: 480, y: 590, x2: 80, y2: 310 },
      twrLocation: {x: 504, y: 290}
    },
    {
      icao: 'efjo',
      fmisid: '101608',
      qfesub: 14.5,
      windmeters: [
        { name: "10 TDZ", x: 100, y: 50, x2: 100, y2: 40, type: "end", rwyh: 110.3 },
        { name: "28 TDZ", x: 786, y: 50, x2: 786, y2: 160, type: "end", rwyh: 110.3 }
      ],
      ceilometers: [
        { name: "10 TDZ", x: 100, y: 600, x2: 70, y2: 500  },
        { name: "28 EXT", x: 800, y: 600, x2: 800, y2: 620 }
      ],
      rvr: [
        { name: "RVR 10 TDZ" },{ name: "RVR 28 TDZ" }
      ],
      weather: { x: 430, y: 180, x2: 430, y2: 180 },
      twrLocation: {x: 350, y: 310}
    },

    {
      icao: 'efjy',
      fmisid: '137208',
      qfesub: 16.7,
      windmeters: [
        { name: "12 TDZ", x: 80, y: 40, x2: 40, y2: 340, type: "end", rwyh: 133.9 },
        { name: "30 TDZ", x: 780, y: 40, x2: 840, y2: 300, type: "end", rwyh: 133.9 }
      ],
      ceilometers: [
        { name: "12 EXT", x: 140, y: 610, x2: 40, y2: 80  },
        { name: "30 EXT", x: 800, y: 610, x2: 890, y2: 600 }
      ],
      rvr: [
        { name: "RVR 12 TDZ" },{ name: "RVR 12/30 MID" },{ name: "RVR 30 TDZ" }
      ],
      weather: { x: 420, y: 140, x2: 600, y2: 100 },
      twrLocation: {x: 250, y: 46}
    },
    {
      icao: 'efke',
      fmisid: '101840',
      qfesub: 2.2,
      windmeters: [
        { name: "36 TDZ", x: 100, y: 50, x2: 140, y2: 460, type: "end", rwyh: 7.5 },
        { name: "18/36 MID", x: 440, y: 50, x2: 720, y2: 270, type: "mid", rwyh: 7.5 },
        { name: "18 TDZ", x: 786, y: 50, x2: 200, y2: 40, type: "end", rwyh: 7.5 }
      ],
      ceilometers: [
        { name: "36 EXT", x: 100, y: 600, x2: 680, y2: 620  },
        { name: "18 EXT", x: 800, y: 600, x2: 780, y2: 100 }
      ],
      rvr: [
        { name: "RVR 36 TDZ" },{ name: "RVR 18/36 MID" },{ name: "RVR 36 TDZ" }
      ],
      weather: { x: 480, y: 590, x2: 80, y2: 310 },
      twrLocation: {x: 330, y: 60}
    },
    {
      icao: 'efki',
      fmisid: '101725',
      qfesub: 17.6,
      windmeters: [
        { name: "07 TDZ", x: 100, y: 50, x2: 100, y2: 50, type: "end", rwyh: 79.6 },
        { name: "07 MID", x: 440, y: 50, x2: 440, y2: 50, type: "mid", rwyh: 79.6 },
        { name: "25 TDZ", x: 786, y: 50, x2: 786, y2: 50, type: "end", rwyh: 79.6 }
      ],
      ceilometers: [
        { name: "07 EXT", x: 100, y: 600, x2: 100, y2: 600  },
        { name: "25 TDZ", x: 800, y: 600, x2: 800, y2: 600 }
      ],
      rvr: [
        { name: "RVR 07 TDZ" },{ name: "RVR 25 TDZ" }
      ],
      weather: { x: 416, y: 590, x2: 416, y2: 590 },
      twrLocation: {x: 156, y: 264}
    },
    {
      icao: 'efkk',
      fmisid: '101662',
      qfesub: 3.1,
      windmeters: [
        { name: "01 TDZ", x: 100, y: 50, x2: 100, y2: 450, type: "end", rwyh: 10.6 },
        { name: "19 TDZ", x: 786, y: 50, x2: 140, y2: 50, type: "end", rwyh: 10.6 }
      ],
      ceilometers: [
        { name: "01 TDZ", x: 100, y: 600, x2: 680, y2: 600  },
        { name: "19 EXT", x: 800, y: 600, x2: 740, y2: 160 }
      ],
      rvr: [
        { name: "RVR 01 TDZ" },{ name: "RVR 19 TDZ" }
      ],
      weather: { x: 416, y: 590, x2: 700, y2: 350 },
      twrLocation: {x: 340, y: 40}
    },
    {
      icao: 'efks',
      fmisid: '101886',
      qfesub: 31.4,
      windmeters: [
        { name: "12 TDZ", x: 340, y: 50, x2: 580, y2: 50, type: "end", rwyh: 132.2 },
        { name: "30 TDZ", x: 750, y: 50, x2: 870, y2: 350, type: "end", rwyh: 132.2 }
      ],
      ceilometers: [
        { name: "12 EXT", x: 100, y: 560, x2: 60, y2: 320  },
        { name: "30 TDZ", x: 800, y: 560, x2: 380, y2: 610 }
      ],
      rvr: [
        { name: "RVR 12 TDZ" },{ name: "RVR 30 TDZ" }
      ],
      weather: { x: 416, y: 550, x2: 150, y2: 450 },
      twrLocation: {x: 106, y: 40}
    },
    {
      icao: 'efkt',
      fmisid: '101986',
      qfesub: 23.5,
      windmeters: [
        { name: "16 TDZ", x: 120, y: 50, x2: 80, y2: 50, type: "end", rwyh: 166.1 },
        { name: "34 TDZ", x: 750, y: 50, x2: 170, y2: 450, type: "end", rwyh: 166.1 }
      ],
      ceilometers: [
        { name: "16 EXT", x: 100, y: 560, x2: 660, y2: 120  },
        { name: "34 TDZ", x: 800, y: 560, x2: 780, y2: 540 }
      ],
      rvr: [
        { name: "RVR 16 TDZ" },{ name: "RVR 16/34 MID" },{ name: "RVR 34 TDZ" }
      ],
      weather: { x: 416, y: 550, x2: 700, y2: 300 },
      twrLocation: {x: 550, y: 40}
    },
    {
      icao: 'efku',
      fmisid: '101570',
      qfesub: 11.8,
      windmeters: [
        { name: "15 EXT", x: 120, y: 50, x2: 60, y2: 50, type: "end", rwyh: 157.2 },
        { name: "15/33 MID", x: 440, y: 50, x2: 740, y2: 220, type: "mid", rwyh: 157.2 },
        { name: "33 TDZ", x: 750, y: 50, x2: 140, y2: 470, type: "end", rwyh: 157.2 }
      ],
      ceilometers: [
        { name: "15 EXT", x: 100, y: 590, x2: 660, y2: 60  },
        { name: "33 EXT", x: 800, y: 590, x2: 820, y2: 570 }
      ],
      rvr: [
        { name: "RVR 15 TDZ" },{ name: "RVR 15/33 MID" },{ name: "RVR 33 TDZ" }
      ],
      weather: { x: 416, y: 590, x2: 80, y2: 320 },
      twrLocation: {x: 298, y: 276}
    },
    {
      icao: 'eflp',
      fmisid: '101237',
      qfesub: 12.7,
      windmeters: [
        { name: "06 TDZ", x: 120, y: 50, x2: 90, y2: 160, type: "end", rwyh: 66.6 },
        { name: "24 TDZ", x: 750, y: 50, x2: 460, y2: 50, type: "end", rwyh: 66.7 }
      ],
      ceilometers: [
        { name: "06 TDZ", x: 100, y: 590, x2: 300, y2: 610  },
        { name: "24 EXT", x: 800, y: 590, x2: 900, y2: 400 }
      ],
      rvr: [
        { name: "RVR 06 TDZ" },{ name: "RVR 06/24 MID" },{ name: "RVR 24 TDZ" }
      ],
      weather: { x: 416, y: 590, x2: 680, y2: 550 },
      twrLocation: {x: 510, y: 276}
    },
    {
      icao: 'efma',
      fmisid: '100907',
      qfesub: 0.7,
      windmeters: [
        { name: "03 TDZ", x: 120, y: 50, x2: 90, y2: 420, type: "end", rwyh: 23.4 },
        { name: "21 TDZ", x: 750, y: 50, x2: 240, y2: 60, type: "end", rwyh: 23.4 }
      ],
      ceilometers: [
        { name: "03 TDZ", x: 100, y: 590, x2: 660, y2: 570  },
        { name: "21 EXT", x: 800, y: 590, x2: 820, y2: 160 }
      ],
      rvr: [
        { name: "RVR 03 TDZ" },{ name: "RVR 03 MID" },{ name: "RVR 21 TDZ" }
      ],
      weather: { x: 416, y: 590, x2: 780, y2: 340 },
      twrLocation: {x: 530, y: 290}
    },
    {
      icao: 'efmi',
      fmisid: '855522',
      qfesub: 12.0,
      windmeters: [
        { name: "11/29 MID", x: 320, y: 50, x2: 440, y2: 50, type: "mid", rwyh: 112.6 },
      ],
      ceilometers: [
        { name: "11 THR", x: 100, y: 590, x2: 100, y2: 460  },
      ],
      rvr: [
        { name: "RVR 11 TDZ" }
      ],
      weather: { x: 416, y: 570, x2: 416, y2: 570 },
      twrLocation: {x: 476, y: 40}
    },
    {
      icao: 'efou',
      fmisid: '101786',
      qfesub: 1.8,
      windmeters: [
        { name: "12 TDZ L", x: 40, y: 40, x2: 480, y2: 40, type: "end", rwyh: 121.0 },
        { name: "12/30 MID", x: 376, y: 40, x2: 180, y2: 470, type: "mid", rwyh: 121.0 },
        { name: "30 TDZ L", x: 760, y: 40, x2: 800, y2: 140, type: "end", rwyh: 121.0 }
      ],
      ceilometers: [
        { name: "12 EXT", x: 100, y: 590, x2: 40, y2: 60  },
        { name: "30 EXT", x: 800, y: 590, x2: 920, y2: 580 }
      ],
      rvr: [
        { name: "RVR 12 TDZ L" },{ name: "RVR 12/30 MID" },{ name: "RVR 30 TDZ R" }
      ],
      weather: { x: 416, y: 590, x2: 460, y2: 590 },
      twrLocation: {x: 570, y: 36}
    },
    {
      icao: 'efpo',
      fmisid: '101044',
      qfesub: 1.6,
      windmeters: [
        { name: "12 TDZ", x: 40, y: 50, x2: 500, y2: 40, type: "end", rwyh: 125.8 },
        { name: "30 TDZ", x: 760, y: 50, x2: 800, y2: 140, type: "end", rwyh: 125.8 }
      ],
      ceilometers: [
        { name: "12 EXT", x: 100, y: 590, x2: 40, y2: 60  },
        { name: "30 EXT", x: 800, y: 590, x2: 920, y2: 580 }
      ],
      rvr: [
        { name: "RVR 12 TDZ" },{ name: "RVR 30 TDZ" }
      ],
      weather: { x: 410, y: 570, x2: 180, y2: 470 },
      twrLocation: {x: 196, y: 10}
    },
    {
      icao: 'efsa',
      fmisid: '101430',
      qfesub: 11.3,
      windmeters: [
        { name: "12 TDZ", x: 40, y: 50, x2: 480, y2: 50, type: "end", rwyh: 125.7 },
        { name: "30 TDZ", x: 760, y: 50, x2: 800, y2: 200, type: "end", rwyh: 125.7 }
      ],
      ceilometers: [
        { name: "12 EXT", x: 100, y: 590, x2: 40, y2: 360  },
        { name: "30 TDZ", x: 800, y: 590, x2: 920, y2: 580 }
      ],
      rvr: [
        { name: "RVR 12 TDZ" },{ name: "RVR 12/30 MID" },{ name: "RVR 30 TDZ" }
      ],
      weather: { x: 386, y: 190, x2: 280, y2: 570 },
      twrLocation: {x: 270, y: 294}
    },
    {
      icao: 'efsi',
      fmisid: '137188',
      qfesub: 11.0,
      windmeters: [
        { name: "14 TDZ", x: 40, y: 60, x2: 520, y2: 50, type: "end", rwyh: 136.2 },
        { name: "32 TDZ", x: 760, y: 60, x2: 820, y2: 340, type: "end", rwyh: 136.2 }
      ],
      ceilometers: [
        { name: "14 TDZ", x: 100, y: 590, x2: 60, y2: 280  },
        { name: "32 TDZ", x: 800, y: 590, x2: 380, y2: 600 }
      ],
      rvr: [
        { name: "RVR 14 TDZ" },{ name: "RVR 32 TDZ" }
      ],
      weather: { x: 386, y: 190, x2: 100, y2: 440 },
      twrLocation: {x: 226, y: 274}
    },
    {
      icao: 'eftp',
      fmisid: '101118',
      qfesub: 14.2,
      windmeters: [
        { name: "06 TDZ", x: 40, y: 40, x2: 60, y2: 170, type: "end", rwyh: 64.4 },
        { name: "24 TDZ", x: 790, y: 40, x2: 368, y2: 40, type: "end", rwyh: 64.4 }
      ],
      ceilometers: [
        { name: "06 TDZ", x: 100, y: 610, x2: 20, y2: 600  },
        { name: "24 TDZ", x: 800, y: 610, x2: 920, y2: 220 }
      ],
      rvr: [
        { name: "RVR 06 TDZ" },{ name: "RVR 06/24 MID" },{ name: "RVR 24 TDZ" }
      ],
      weather: { x: 400, y: 120, x2: 620, y2: 520 },
      twrLocation: {x: 550, y: 20}
    },
    {
      icao: 'eftu',
      fmisid: '101065',
      qfesub: 5.9,
      windmeters: [
        { name: "08 TDZ", x: 40, y: 70, x2: 40, y2: 70, type: "end", rwyh: 84.8 },
        { name: "26 TDZ", x: 790, y: 70, x2: 790, y2: 70, type: "end", rwyh: 84.8 }
      ],
      ceilometers: [
        { name: "08 THR", x: 100, y: 610, x2: 100, y2: 610  },
        { name: "26 TDZ", x: 800, y: 610, x2: 800, y2: 610 }
      ],
      rvr: [
        { name: "RVR 08 TDZ" },{ name: "RVR 08/26 MID" },{ name: "RVR 26 TDZ" }
      ],
      weather: { x: 400, y: 180, x2: 400, y2: 180 },
      twrLocation: {x: 566, y: 280}
    },
    {
      icao: 'efut',
      fmisid: '101191',
      qfesub: 12.4,
      windmeters: [
        { name: "07 TDZ", x: 40, y: 50, x2: 40, y2: 70, type: "end", rwyh: 78.0 },
        { name: "25 TDZ", x: 790, y: 50, x2: 790, y2: 50, type: "end", rwyh: 78.0 }
      ],
      ceilometers: [
        { name: "07 EXT", x: 70, y: 610, x2: 70, y2: 620  },
        { name: "25 TDZ", x: 800, y: 610, x2: 840, y2: 500 }
      ],
      rvr: [
        { name: "RVR 07 TDZ" },{ name: "RVR 25 TDZ" }
      ],
      weather: { x: 400, y: 180, x2: 400, y2: 180 },
      twrLocation: {x: 154, y: 332}
    },
    {
      icao: 'efva',
      fmisid: '101462',
      qfesub: 0.7,
      windmeters: [
        { name: "16 TDZ", x: 40, y: 70, x2: 40, y2: 70, type: "end", rwyh: 163.2 },
        { name: "34 TDZ", x: 790, y: 70, x2: 140, y2: 450, type: "end", rwyh: 163.2 }
      ],
      ceilometers: [
        { name: "16 EXT", x: 70, y: 610, x2: 660, y2: 120  },
        { name: "34 EXT", x: 800, y: 610, x2: 800, y2: 560 }
      ],
      rvr: [
        { name: "RVR 16 TDZ" },{ name: "RVR 16/34 MID" },{ name: "RVR 34 TDZ" }
      ],
      weather: { x: 400, y: 180, x2: 700, y2: 320 },
      twrLocation: {x: 560, y: 290}
    },
];

const wawaToCode = {
    '00': 'NSW', // Ei merkittäviä sääilmiöitä
    '04': 'BR',  // Auerta, savua tai pölyä, näkyvyys >= 1 km (BR = mist)
    '05': 'BR',  // same as above, but visibility < 1 km
    '10': 'FG',  // Utua (Fog)

    // Recent rain/snow codes (20-25) - these usually correspond to RERA (recent rain), etc.
    '20': 'RE FG', // Sumua (recent fog)
    '21': 'RE UP', // Sadetta (undefined precipitation type)
    '22': 'RE DZ', // Tihkusadetta (drizzle)
    '23': 'RE RA', // Vesisadetta (rain)
    '24': 'RE SN', // Lumisadetta (snow)
    '25': 'RE FZRA', // Jäätävää vesisadetta (freezing rain)

    // Current rain/snow codes (30-34)
    '30': 'FG',   // SUMUA (Fog)
    '31': 'BLSN', // Sumua tai jääsumua erillisinä hattaroina (blowing snow)
    '32': 'FG',   // Ohentunut sumu
    '33': 'FG',   // Ei merkittäviä muutoksia sumussa
    '34': 'FG',   // Sakeutunut sumu

    // Current rain codes (40-42)
    '40': 'RA',   // Sadetta
    '41': '-RA',   // Heikkoa/kohtalaista sadetta
    '42': '+RA',  // Kovaa sadetta

    // Drizzle (50-56)
    '50': 'DZ',   // Tihkusadetta
    '51': '-DZ',   // Heikkoa tihkua
    '52': 'DZ',   // Kohtalaista tihkua
    '53': '+DZ',  // Kovaa tihkua
    '54': '-FZDZ', // Jäätävää heikkoa tihkua
    '55': 'FZDZ', // Jäätävää kohtalaista tihkua
    '56': '+FZDZ', // Jäätävää kovaa tihkua

    // Rain shower (60-66)
    '60': 'RA',   // Vesisadetta heikkoa
    '61': '-RA',   // Heikkoa vesisadetta
    '62': 'RA',   // Kohtalaista vesisadetta
    '63': '+RA',  // Kovaa vesisadetta
    '64': '-FZRA', // Jäätävää heikkoa vesisadetta
    '65': 'FZRA', // Jäätävää kohtalaista vesisadetta
    '66': '+FZRA', // Jäätävää kovaa vesisadetta

    // Rain/snow mixed (67-68)
    '67': 'RASN', // Heikkoa lumensekaista vesisadetta
    '68': '+RASN',// Kohtalaista/kovaa lumensekaista vesisadetta

    // Snow shower (70-78)
    '70': 'SN',   // Lumisadetta
    '71': '-SN',  // Heikkoa lumisadetta
    '72': 'SN',   // Kohtalaista lumisadetta
    '73': '+SN',  // Tiheää lumisadetta
    '74': '-GR',   // Heikkoa jääjyvässadetta (hail/graupel)
    '75': 'GR',   // Kohtalaista jääjyvässadetta
    '76': '+GR',   // Kovaa jääjyvässadetta
    '77': 'GS',   // Lumijyväsiä (small hail)
    '78': 'IC',   // Jääkiteitä (ice crystals)

    // Showers or intermittent rain (80-87)
    '80': 'SHRA', // Kuroja tai ajoittaista sadetta
    '81': '-SHRA',  // Heikkoja vesikuuroja
    '82': 'SHRA',   // Kohtalaisia vesikuuroja
    '83': '+SHRA',  // Kovia vesikuuroja
    '84': '+SHRA',  // Ankaria vesikuuroja (>32 mm/h)
    '85': '-SHSN',  // Heikkoja lumikuuroja
    '86': 'SHSN',   // Kohtalaisia lumikuuroja
    '87': '+SHSN',  // Kovia lumikuuroja

    '89': 'GR',   // Raekuuroja
};

export const getWeatherCode = (wawa) => {
    if (wawa == null) return null;
    const key = String(parseInt(wawa));
    return wawaToCode[key] || null;
};

export const updateWindComponents = (rwyh, windDir, windSpd) => {
  const toRad = deg => deg * Math.PI / 180;
  const fmt = n => typeof n === "number" ? String(n).padStart(2, "0") : n;

  const get = (rwy) => {
    const diff = ((windDir - rwy + 360) % 360);
    const angle = toRad(diff);
    const cross = Math.round(windSpd * Math.sin(angle));
    const tail = Math.round(windSpd * Math.cos(angle));
    return {
      crosswind: isNaN(cross) ? "//" : fmt(Math.abs(cross)),
      tailwind: isNaN(tail) || tail <= 0 ? "" : fmt(tail)
    };
  };

  try {
    const primary = get(rwyh);
    const reciprocal = get((rwyh + 180) % 360);

    const tailEls = document.querySelectorAll('[data-name="tailwind"]');
    const crossEls = document.querySelectorAll('[data-name="crosswind"]');

    // First element = opposite runway
    if (tailEls[0]) tailEls[0].textContent = reciprocal.tailwind;
    if (crossEls[0]) crossEls[0].textContent = reciprocal.crosswind;

    // Second element = primary runway
    if (tailEls[1]) tailEls[1].textContent = primary.tailwind;
    if (crossEls[1]) crossEls[1].textContent = primary.crosswind;

  } catch {
    document.querySelectorAll('[data-name="tailwind"], [data-name="crosswind"]')
      .forEach(el => el.textContent = "//");
  }
};

export const calculateWindValues = (wd, ws, wg, randomizersArray, metar) => {
  const mpsToKnots = (mps) => mps * 1.94384;
  const toNearestTen = (val) => Math.round(val / 10) * 10;

  // Extract variable wind range from METAR (e.g., 120V190)
  const parseVrbRangeFromMetar = (metarText) => {
    const match = metarText?.match(/(\d{3})V(\d{3})/);
    if (match) {
      return {
        metarFrom: parseInt(match[1], 10),
        metarTo: parseInt(match[2], 10),
      };
    }
    return null;
  };

  const metarVrb = parseVrbRangeFromMetar(metar);

  const processPart = (baseWd, baseWs, baseWg, rand) => {
    const directionOffset = rand.direction ?? 0;
    const ccOffset = rand.cc ?? 0;
    const cOffset = rand.c ?? 0;

    // Wind direction
    let direction = (baseWd + directionOffset) % 360;
    if (direction < 0) direction += 360;
    direction = toNearestTen(direction);

    // Wind speed (in knots)
    let speed = mpsToKnots(baseWs) + (rand.speed ?? 0);
    speed = Math.round(speed);

    // Wind gust
    let gust = mpsToKnots(baseWg) + (rand.max ?? 0);
    gust = Math.round(gust);

    // Wind min (based on speed)
    let windMin = mpsToKnots(baseWs);
    if (windMin < 10) {
      windMin = windMin - (rand.min ?? 0);
      windMin = windMin < 1 ? 0 : Math.round(windMin);
    } else {
      windMin = windMin - (rand.min ?? 0) - 5;
      windMin = windMin < 1 ? 0 : Math.round(windMin);
    }

    // Variable direction range
    let vrbFrom = (direction - ccOffset + 360) % 360;
    let vrbTo = (direction + cOffset) % 360;

    // Override with METAR values, if they exist and don't already contain direction
    if (metarVrb) {
      let { metarFrom, metarTo } = metarVrb;
    
      const directionInRange = (
        metarFrom <= metarTo
          ? direction >= metarFrom && direction <= metarTo
          : direction >= metarFrom || direction <= metarTo // range crosses 360° boundary
      );
    
      if (!directionInRange) {
        // Adjust the closer bound to include direction ±10°
        const diffFrom = (direction - metarFrom + 360) % 360;
        const diffTo = (metarTo - direction + 360) % 360;
    
        if (diffFrom < diffTo) {
          // Expand metarTo
          metarTo = (direction + 10) % 360;
        } else {
          // Expand metarFrom
          metarFrom = (direction - 10 + 360) % 360;
        }
      }
    
      vrbFrom = metarFrom;
      vrbTo = metarTo;
    }    
    return [direction, speed, gust, windMin, vrbFrom, vrbTo];
  };

  const randomizers = randomizersArray[0];

  const part1 = processPart(wd, ws, wg, randomizers.firstPart[0]);
  const part2 = processPart(wd, ws, wg, randomizers.secondPart[0]);
  const part3 = processPart(wd, ws, wg, randomizers.thirdPart[0]);

  return {
    part1,
    part2,
    part3
  };
};

/*
  part1: [direction, speed, gust, windMin, vrbFrom, vrbTo],
  part2: [ ... ],
  part3: [ ... ]
*/